<app-view-dashboard-component>
  <div modalTitle>
    {{ 'nav.worklist' | translate }}
  </div>
  <app-shift></app-shift>
</app-view-dashboard-component>